(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeDemographicsComponent', psychIntakeDemographicsComponent);

    psychIntakeDemographicsComponent.$inject = [];

    function psychIntakeDemographicsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeDemographicsController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/demographics.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeDemographicsController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeDemographicsController($scope, $stateParams, $element) {
        var vm = this;

        function init() {}

        init();
    }
})();
